import { withDynamicProps } from "../HOC/withDynamicProps";

export const Content = withDynamicProps(({ content }) => {
	return (<>{content}</>);
})